import React from 'react';
import { useTheme } from 'styled-components';

import { Badge } from '@ui-library/badge';
import { SmallText } from '@ui-library/typography';

import { useDesignVariant } from '../designVariantContext';

export const RecommendedBadge: React.FC = () => {
  const theme = useTheme();
  const variant = useDesignVariant();

  return (
    <Badge
      variant={variant}
      size="small"
      bgColor={variant ? theme.token.next.palette.blue50 : theme.token['blue.3']}
      label={
        <SmallText
          color={variant ? theme.token.next.palette.grey700 : theme.token.colorPrimaryText}
          fontWeight={500}
        >
          Recommended
        </SmallText>
      }
    />
  );
};
